import { z } from "zod"

import { TenantIdSchema } from "./auth.js"
import { CountryCodeSchema, PartyIdSchema, UnlocodeSchema } from "./id-schemas.js"

/**
 * Party — shipper / consignee / notify-N entity attached to a Shipment.
 *
 * Real shipment data shows >=4-deep notify chains and "shipper-as-chain"
 * patterns ("X on behalf of Y on behalf of RAM-OS"). Modeled via
 * `parentPartyId` self-reference. `role` is the canonical v1 set; tenant
 * -custom roles will land via a Settings-managed registry post-v1.
 */

const Bounded = (max = 256) => z.string().min(1).max(max)
const IsoDateTime = z.string().datetime()

export const PartyRoleSchema = z.enum([
	"shipper",
	"consignee",
	"notify1",
	"notify2",
	"notify3",
	"notify4",
	"notify5",
	"forwarder",
	"agent",
	"customs_broker",
])
export type PartyRole = z.infer<typeof PartyRoleSchema>

export const PartySchema = z.object({
	id: PartyIdSchema,
	tenantId: TenantIdSchema,
	name: Bounded(256),
	role: PartyRoleSchema,
	parentPartyId: PartyIdSchema.optional(),
	countryCode: CountryCodeSchema.optional(),
	unlocode: UnlocodeSchema.optional(),
	address: z.string().max(1024).optional(),
	contactEmail: z.string().email().max(254).optional(),
	contactPhone: z.string().max(32).optional(),
	createdAt: IsoDateTime,
	updatedAt: IsoDateTime,
})
export type Party = z.infer<typeof PartySchema>
